import { darken } from "@material-ui/core/styles";
import type { DefaultTheme } from "styled-components";

export const BLUE = "#445a82";
export const GRAY90 = "#5a5a5a";

export const THEME: DefaultTheme = {
  body: {
    background: "#ededed",
    color: "#212322",
    fontFamily: '"Graphik", sans-serif',
    fontWeight: 400,
  },
  components: {
    loader: {
      color: "#A5A5A5",
      size: "48px",
    },
    loaderEllipsis: {
      color: BLUE,
    },
    input: {
      background: "transparent",
      color: "#000000",
      borderColor: "#EDEDED",
      outlineColor: "black",
      placeholderColor: "#AAA",
    },
    button: {
      background: BLUE,
      color: "#FFFFFF",
      hoverBackground: darken(BLUE, 0.1),
      disabledBackground: GRAY90,
    },
  },
  colors: {
    blue: BLUE,
    gray: "#212322",
    grayLight: "#5a5a5a",
    grayAccent: "#88888d",
    gray50: "#ededed",
    gray100: "#212322",
  },
  border: {
    radius: "2px",
    grayMid: "1px solid #ededed",
  },
};

export const DARK_THEME: DefaultTheme = {
  ...THEME,
  body: {
    ...THEME.body,
    background: "#000000",
    color: "#FFFFFF",
  },
  components: {
    ...THEME.components,
    loaderEllipsis: {
      ...THEME.components.loaderEllipsis,
      color: "#A5A5A5",
    },
    input: {
      ...THEME.components.input,
      color: "#fff",
      borderColor: "#292B36",
      outlineColor: "#5C7AD0",
    },
    button: {
      ...THEME.components.button,
      background: "#3B68F6",
      hoverBackground: "#3B68F6",
      disabledBackground: "#282C38",
    },
  },
};
